var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsqIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1812_65324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0558 5.83335C15.3793 4.80584 14.4631 3.96389 13.3887 3.38235C12.3142 2.80082 11.1148 2.49772 9.89709 2.50001C8.68147 2.49926 7.48448 2.80312 6.41238 3.38461C5.34029 3.96611 4.42627 4.80725 3.75146 5.83335",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48676 2.5C8.84676 3.5405 8.34272 4.661 7.9873 5.83333",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3076 2.5C10.9482 3.54042 11.4528 4.66091 11.8087 5.83333",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0558 14.1665C15.3793 15.194 14.4631 16.036 13.3887 16.6175C12.3142 17.199 11.1148 17.5021 9.89709 17.4998C8.68147 17.5006 7.48448 17.1967 6.41238 16.6152C5.34029 16.0337 4.42627 15.1926 3.75146 14.1665",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48676 17.4998C8.84676 16.4593 8.34272 15.3388 7.9873 14.1665",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3076 17.4998C10.9482 16.4594 11.4528 15.3389 11.8087 14.1665",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68555 8.3335L2.50671 11.6668L3.73847 8.3335L4.97022 11.6668L5.79139 8.3335",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0029 8.3335L14.8241 11.6668L16.0558 8.3335L17.2876 11.6668L18.1088 8.3335",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84424 8.3335L8.66541 11.6668L9.89716 8.3335L11.1289 11.6668L11.9501 8.3335",
    stroke: "#F79E1B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1812_65324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.708,
    height: 20,
    fill: "white",
    transform: "translate(0.043457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsqIconOrange);
export default __webpack_public_path__ + "static/media/bsq-icon-orange.657e071d98ff89b69f63ee58de2b4ea8.svg";
export { ForwardRef as ReactComponent };